// Names for the things on the table, all of them taken from the server catalogue. Nothing here is
// written by hand: how a deck calls its seeds, how it calls its values and how every rung of the
// Briscola chiamata auction reads are decisions that live in the engine, and a second copy in this
// client would drift the first time one of them changes.

import { Protocol, ServerProtocol } from '../generated/protocol.js';

const PASS_LEVEL = -1;

export class Vocabulary {
  #seedsByDeck = new Map();
  #cardTypesByDeck = new Map();
  #bidsByKey = new Map();
  #ranksByCallable = new Map();

  constructor(catalogue) {
    for (const deck of catalogue[ServerProtocol.DecksID] ?? []) {
      const deckType = deck[Protocol.JSONDeckTypeID];
      this.#seedsByDeck.set(
        deckType,
        new Map(
          (deck[ServerProtocol.SeedsID] ?? []).map((entry) => [
            entry[Protocol.JSONSeedID],
            entry[ServerProtocol.NameID],
          ]),
        ),
      );
      this.#cardTypesByDeck.set(
        deckType,
        new Map(
          (deck[ServerProtocol.CardTypesID] ?? []).map((entry) => [
            entry[Protocol.JSONCardTypeID],
            entry[ServerProtocol.NameID],
          ]),
        ),
      );
    }

    for (const entry of catalogue[ServerProtocol.BidLabelsID] ?? []) {
      const key = `${entry[ServerProtocol.AuctionModeID]}/${entry[ServerProtocol.CallableRanksID]}`;
      this.#bidsByKey.set(key, {
        labels: entry[ServerProtocol.LabelsID] ?? [],
        pass: entry[ServerProtocol.PassLabelID] ?? 'Passo',
      });
    }

    for (const entry of catalogue[ServerProtocol.CallRanksID] ?? []) {
      this.#ranksByCallable.set(
        entry[ServerProtocol.CallableRanksID],
        entry[ServerProtocol.RanksID] ?? [],
      );
    }
  }

  seedName(seed, deckType) {
    return this.#seedsByDeck.get(deckType)?.get(seed) ?? '';
  }

  cardTypeName(cardType, deckType) {
    return this.#cardTypesByDeck.get(deckType)?.get(cardType) ?? '';
  }

  // "Asso di spade", the way a card is said at a table
  cardName(card, deckType) {
    if (!card) return '';
    const value = this.cardTypeName(card.cardType, deckType);
    const seed = this.seedName(card.seed, deckType);
    return seed ? `${value} di ${seed}` : value;
  }

  bidLabel(level, auctionMode, callableRanks) {
    const entry = this.#bidsByKey.get(`${auctionMode}/${callableRanks}`);
    if (!entry) return String(level);
    if (level === PASS_LEVEL) return entry.pass;
    return entry.labels[level] ?? String(level);
  }

  rankNames(callableRanks) {
    return this.#ranksByCallable.get(callableRanks) ?? [];
  }
}
